/* ============================================================
   SWISS HARDWARE THEME JS — V5 FINAL
   ============================================================ */
(function() {
  'use strict';

  /* === Announcement bar rotation === */
  var msgs = document.querySelectorAll('.topbar__msg');
  if (msgs.length > 1) {
    var idx = 0;
    setInterval(function() {
      msgs[idx].classList.remove('active');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('active');
    }, 4000);
  }

  /* === Sticky header shadow === */
  var header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 60) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }, { passive: true });
  }

  /* === Mobile nav toggle === */
  var toggle = document.getElementById('mobileToggle');
  var nav = document.getElementById('mainNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      nav.classList.toggle('open');
      var isOpen = nav.classList.contains('open');
      toggle.setAttribute('aria-expanded', isOpen);
      // Change icon
      if (isOpen) {
        toggle.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      } else {
        toggle.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
      }
    });
  }

  /* === Back to top === */
  var btt = document.getElementById('backToTop');
  if (btt) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 500) {
        btt.classList.add('visible');
      } else {
        btt.classList.remove('visible');
      }
    }, { passive: true });
    btt.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* === FAQ accordions === */
  document.querySelectorAll('.faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.faq__item');
      // Close others
      document.querySelectorAll('.faq__item.active').forEach(function(other) {
        if (other !== item) {
          other.classList.remove('active');
          other.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('active');
      this.setAttribute('aria-expanded', item.classList.contains('active'));
    });
  });

  /* === Brands marquee pause on hover === */
  document.querySelectorAll('.brands__track').forEach(function(track) {
    track.addEventListener('mouseenter', function() {
      this.style.animationPlayState = 'paused';
    });
    track.addEventListener('mouseleave', function() {
      this.style.animationPlayState = 'running';
    });
  });

  /* === Smooth scroll for anchor links === */
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* === Simple scroll reveal animation === */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.pc-card, .pro-card, .review-card, .whyus__card, .faq__item, .trust__item').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      revealObserver.observe(el);
    });
  }

})();
